import * as constants from "../constants/CONSTANT";

const ObjectConfigApi = {
  async fetchAllConfigs() {
    const token = localStorage.getItem("token");
    console.log("Calling fetchAllConfigs ");
    let response = await fetch(constants.API_BASE_URL + "/api/objectconfig", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    return await response.json();
  },

  async fetchObjectConfigs() {
    const token = localStorage.getItem("token");
    console.log("Calling fetchAllConfigs ");
    let response = await fetch(
      constants.API_BASE_URL + "/api/objectconfig/configs",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  async fetchLeadMappingObjects() {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/objectconfig/lead-mapping-configs",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  async fetchConfigObjectByNameWithFields(objectName) {
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + `/api/objectconfig/${objectName}`,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  async fetchPathFields(objectName) {
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + `/api/objectconfig/path-fields/${objectName}`,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  async saveConfig(configPayload) {
    console.log("Saving Object Config Payload =>>", configPayload);
    const token = localStorage.getItem("token");

    let response = await fetch(constants.API_BASE_URL + "/api/objectconfig", {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(configPayload),
    });

    return await response.json();
  },

  /**
   * Merges `lineItemWizard` into object_config.config for opportunity, quote, or order (admin).
   * @param {string} objectName
   * @param {object|null} lineItemWizard
   */
  async saveLineItemWizardConfig(objectName, lineItemWizard) {
    const token = localStorage.getItem("token");
    const name = encodeURIComponent(String(objectName || "").trim());
    const response = await fetch(
      `${constants.API_BASE_URL}/api/objectconfig/line-item-wizard-config/${name}`,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ lineItemWizard }),
      }
    );
    return await response.json();
  },



  async saveListView(objectName, configPayload) {
    console.log("Saving Object Config Payload =>>", configPayload);
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + `/api/objectconfig/listview/${objectName}`,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(configPayload),
      }
    );

    return await response.json();
  },

  async trashField(objectName, fieldId) {
    console.log("Trashing field:", { objectName, fieldId });
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + "/api/objectconfig/trash/field",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          objectName,
          fieldId
        }),
      }
    );

    return await response.json();
  },

  async getFieldReferences(objectName, fieldId) {
    console.log("Checking field references:", { objectName, fieldId });
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + "/api/objectconfig/fields/references",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          objectName,
          fieldId,
        }),
      }
    );

    return await response.json();
  },

  async getTrashedFields(objectName) {
    console.log("Getting trashed fields for:", objectName);
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + `/api/objectconfig/trash/fields/${objectName}`,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  async permanentlyDeleteField(objectName, fieldId) {
    console.log("Permanently deleting field:", { objectName, fieldId });
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + `/api/objectconfig/trash/field/${objectName}/${fieldId}`,
      {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  async restoreField(objectName, fieldId) {
    console.log("Restoring field:", { objectName, fieldId });
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + `/api/objectconfig/trash/restore/${objectName}/${fieldId}`,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  async trashObject(objectName) {
    console.log("Trashing object:", objectName);
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + "/api/objectconfig/trash/object",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          objectName
        }),
      }
    );

    return await response.json();
  },

  async getTrashedObjects() {
    console.log("Getting trashed objects");
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + "/api/objectconfig/trash/objects",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  async getObjectReferences(objectName) {
    console.log("Checking object references:", objectName);
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + "/api/objectconfig/objects/references",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          objectName,
        }),
      }
    );

    return await response.json();
  },

  async permanentlyDeleteObject(objectName) {
    console.log("Permanently deleting object:", objectName);
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + `/api/objectconfig/trash/object/${objectName}`,
      {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  async restoreObject(objectName) {
    console.log("Restoring object:", objectName);
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + `/api/objectconfig/trash/restore/${objectName}`,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    console.log("Restore object response:", response);
    const result = await response.json();
    console.log("Restore object result:", result);
    return result;
  },

  // Save field history mapping configuration
  async saveFieldHistoryMapping({ objectConfigId, newFields, deletedFields }) {
    console.log("Saving field history mapping:", { objectConfigId, newFields, deletedFields });
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + "/api/objectconfig/field-history-mapping",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          objectConfigId,
          newFields,
          deletedFields
        }),
      }
    );

    const result = await response.json();
    console.log("Save field history mapping result:", result);
    return result;
  },

  // Get field history mapping configuration
  async getFieldHistoryMapping(objectConfigId) {
    console.log("Getting field history mapping for:", objectConfigId);
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + `/api/objectconfig/field-history-mapping/${objectConfigId}`,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    const result = await response.json();
    console.log("Get field history mapping result:", result);
    return result;
  },

  async fetchPublishPackages() {
    const token = localStorage.getItem("token");
    const response = await fetch(
      constants.API_BASE_URL + "/api/objectconfig/publishing/packages",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    return await response.json();
  },

  async fetchPublishCatalog(objectName) {
    const token = localStorage.getItem("token");
    const response = await fetch(
      constants.API_BASE_URL + `/api/objectconfig/publishing/catalog/${encodeURIComponent(objectName)}`,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    return await response.json();
  },

  buildStandardCatalogPayload({
    packageKey,
    allowExplore,
    createFields,
    assignPermission,
    setupObject,
    packageRequired,
  }) {
    return {
      packageKey: packageKey != null ? String(packageKey).trim() || null : null,
      allowExplore: allowExplore !== false,
      createFields: createFields !== false,
      assignPermission: assignPermission !== false,
      setupObject: setupObject === true,
      packageRequired: packageRequired !== false,
    };
  },

  async publishStandardObject(payload) {
    const token = localStorage.getItem("token");
    const body = {
      objectName: payload.objectName,
      ...ObjectConfigApi.buildStandardCatalogPayload(payload),
    };
    const response = await fetch(
      constants.API_BASE_URL + "/api/objectconfig/publishing/publish-standard",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(body),
      }
    );
    return await response.json();
  },

  async updateStandardObjectCatalog(objectName, payload) {
    const token = localStorage.getItem("token");
    const response = await fetch(
      constants.API_BASE_URL + `/api/objectconfig/publishing/catalog/${encodeURIComponent(objectName)}`,
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(ObjectConfigApi.buildStandardCatalogPayload(payload)),
      }
    );
    return await response.json();
  },

  async getEmbeddingIndexingOptions() {
    const token = localStorage.getItem("token");
    const response = await fetch(
      constants.API_BASE_URL + "/api/objectconfig/embeddings/indexing-options",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    return await response.json();
  },

  async indexStandardSchemaEmbeddings() {
    const token = localStorage.getItem("token");
    const response = await fetch(
      constants.API_BASE_URL + "/api/objectconfig/embeddings/index-standard-schema",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      }
    );
    return await response.json();
  },

  async indexTenantSchemaEmbeddings() {
    const token = localStorage.getItem("token");
    const response = await fetch(
      constants.API_BASE_URL + "/api/objectconfig/embeddings/index-schema",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      }
    );
    return await response.json();
  },


};

export default ObjectConfigApi;
